<template>
  <div v-if="isLoading" class="h-40 flex items-center justify-center">
    <Spinner />
  </div>
  <div v-else-if="isError">Something went wrong</div>
  <div v-else class="md:max-w-[500px] w-full">
    <div class="text-gray-300 font-bold text-sm mb-4">
      EDIT ROLE PERMISSIONS
    </div>
    <RoleForm :key="role.id" :role="role" :permissions="permissions" />
    <Protect :permissions="[SYS_PERMISSIONS.SYS_ROLES_MANAGE]">
      <DeleteRole v-if="role.is_deletable" :role="role" />
    </Protect>
  </div>
</template>

<script setup>
import Protect from '@/hoc/Protect.vue';
import { useQuery } from '@tanstack/vue-query';
import { useRoute } from 'vue-router';
import { SYS_PERMISSIONS } from '@/constants.js';
import Spinner from '@ui/components/Spinner.vue';
import requests from '@vuex/requests.js';

import { useStore } from 'vuex';
import RoleForm from './components/roles/RoleForm.vue';
import DeleteRole from './components/roles/DeleteRole.vue';

const route = useRoute();
const { role: roleId } = route.params;
const store = useStore();
const {
  isLoading: isLoaadingRole,
  data: role,
  isError: isErrorRole,
} = useQuery({
  queryKey: ['role', roleId],
  queryFn: () =>
    requests.roles.read(store.getters['workspace/getId'], { id: roleId }),
});

const {
  isLoading: isLoaadingPermissions,
  data: permissions,
  isError: isErrorPermissions,
} = useQuery({
  queryKey: ['permissions'],
  queryFn: () => requests.permissions.get(),
});

const isLoading = isLoaadingRole || isLoaadingPermissions;
const isError = isErrorRole || isErrorPermissions;
</script>
